// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function loadMessages(lang, loadMessages$1) {
  let lang$1 = Stdlib_Option.getOr(lang, "en");
  return Promise.all(loadMessages$1(lang$1));
}

export {
  loadMessages,
}
/* No side effect */
